import {
    CurrencyEnum,
    CountryEnum,
    DegreeTypeEnum,
    GenderEnum,
    LanguageEnum,
} from "@/common/types/enum";

export const enums = {
    currencies: {
        [CurrencyEnum.BRL]: "Real",
        [CurrencyEnum.EUR]: "Euro",
        [CurrencyEnum.USD]: "Dollar",
    },
    countries: {
        [CountryEnum.AFGHANISTAN]: "Afeganistão",
        [CountryEnum.SOUTH_AFRICA]: "África do Sul",
        [CountryEnum.GERMANY]: "Alemanha",
        [CountryEnum.ARGENTINA]: "Argentina",
        [CountryEnum.AUSTRALIA]: "Austrália",
        [CountryEnum.BELGIUM]: "Bélgica",
        [CountryEnum.BRAZIL]: "Brasil",
        [CountryEnum.CANADA]: "Canadá",
        [CountryEnum.CHILE]: "Chile",
        [CountryEnum.CHINA]: "China",
        [CountryEnum.COLOMBIA]: "Colômbia",
        [CountryEnum.SOUTH_KOREA]: "Coreia do Sul",
        [CountryEnum.DENMARK]: "Dinamarca",
        [CountryEnum.EGYPT]: "Egito",
        [CountryEnum.UNITED_ARAB_EMIRATES]: "Emirados Árabes Unidos",
        [CountryEnum.SPAIN]: "Espanha",
        [CountryEnum.UNITED_STATES]: "Estados Unidos",
        [CountryEnum.FRANCE]: "França",
        [CountryEnum.GREECE]: "Grécia",
        [CountryEnum.INDIA]: "Índia",
        [CountryEnum.INDONESIA]: "Indonésia",
        [CountryEnum.IRAN]: "Irã",
        [CountryEnum.ISRAEL]: "Israel",
        [CountryEnum.ITALY]: "Itália",
        [CountryEnum.JAPAN]: "Japão",
        [CountryEnum.MEXICO]: "México",
        [CountryEnum.NIGERIA]: "Nigéria",
        [CountryEnum.NORWAY]: "Noruega",
        [CountryEnum.NEW_ZEALAND]: "Nova Zelândia",
        [CountryEnum.NETHERLANDS]: "Países Baixos",
        [CountryEnum.PAKISTAN]: "Paquistão",
        [CountryEnum.PERU]: "Peru",
        [CountryEnum.POLAND]: "Polônia",
        [CountryEnum.PORTUGAL]: "Portugal",
        [CountryEnum.UNITED_KINGDOM]: "Reino Unido",
        [CountryEnum.RUSSIA]: "Rússia",
        [CountryEnum.SWEDEN]: "Suécia",
        [CountryEnum.SWITZERLAND]: "Suíça",
        [CountryEnum.THAILAND]: "Tailândia",
        [CountryEnum.TURKEY]: "Turquia",
        [CountryEnum.UKRAINE]: "Ucrânia",
        [CountryEnum.URUGUAY]: "Uruguai",
        [CountryEnum.VENEZUELA]: "Venezuela",
        [CountryEnum.VIETNAM]: "Vietnã",
        [CountryEnum.ZIMBABWE]: "Zimbábue",
    },
    degree: {
        [DegreeTypeEnum.HIGH_SCHOOL]: "Ensino Médio",
        [DegreeTypeEnum.ASSOCIATE]: "Tecnólogo/Curso Técnico",
        [DegreeTypeEnum.BACHELOR]: "Bacharelado",
        [DegreeTypeEnum.LICENTIATE]: "Licenciatura",
        [DegreeTypeEnum.SPECIALIZATION]: "Especialização",
        [DegreeTypeEnum.POST_GRADUATE]: "Pós Graduação",
        [DegreeTypeEnum.MASTER]: "Mestrado",
        [DegreeTypeEnum.DOCTORATE]: "Doutorado",
        [DegreeTypeEnum.POST_DOCTORATE]: "Pós-Doutorado",
    },
    gender: {
        [GenderEnum.MALE]: "Masculino",
        [GenderEnum.FEMALE]: "Feminino",
        [GenderEnum.OTHER]: "Não informar",
    },
    language: {
        [LanguageEnum.ENGLISH]: "Inglês",
        [LanguageEnum.SPANISH]: "Espanhol",
        [LanguageEnum.FRENCH]: "Francês",
        [LanguageEnum.GERMAN]: "Alemão",
        [LanguageEnum.PORTUGUESE]: "Português",
        [LanguageEnum.ITALIAN]: "Italiano",
        [LanguageEnum.JAPANESE]: "Japonês",
        [LanguageEnum.KOREAN]: "Coreano",
        [LanguageEnum.CHINESE]: "Chinês",
        [LanguageEnum.RUSSIAN]: "Russo",
        [LanguageEnum.HINDI]: "Hindi",
        [LanguageEnum.ARABIC]: "Árabe",
        [LanguageEnum.TURKISH]: "Turco",
        [LanguageEnum.DUTCH]: "Holandês",
        [LanguageEnum.GREEK]: "Grego",
        [LanguageEnum.SWEDISH]: "Sueco",
        [LanguageEnum.POLISH]: "Polonês",
        [LanguageEnum.NORWEGIAN]: "Norueguês",
        [LanguageEnum.DANISH]: "Dinamarquês",
        [LanguageEnum.FINNISH]: "Finlandês",
        [LanguageEnum.HEBREW]: "Hebraico",
        [LanguageEnum.THAI]: "Tailandês",
        [LanguageEnum.VIETNAMESE]: "Vietnamita",
        [LanguageEnum.INDONESIAN]: "Indonésio",
        [LanguageEnum.UKRAINIAN]: "Ucraniano",
        [LanguageEnum.PERSIAN]: "Persa",
        [LanguageEnum.ROMANIAN]: "Romeno",
        [LanguageEnum.CZECH]: "Tcheco",
        [LanguageEnum.HUNGARIAN]: "Húngaro",
        [LanguageEnum.SLOVAK]: "Eslovaco",
        [LanguageEnum.MALAY]: "Malaio",
        [LanguageEnum.SWAHILI]: "Suaíli",
        [LanguageEnum.FILIPINO]: "Filipino",
        [LanguageEnum.BULGARIAN]: "Búlgaro",
        [LanguageEnum.SERBIAN]: "Sérvio",
        [LanguageEnum.CROATIAN]: "Croata",
        [LanguageEnum.SLOVENIAN]: "Esloveno",
    },
};
